<template>
  <div>
    <v-skeleton-loader v-if="!data_loaded" type="table"></v-skeleton-loader>

    <div v-else>
      <v-row>
        <v-col cols="6" md="3" class="py-0">
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.start_date"
                label="מתאריך"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.start_date"
              @input="(startDateMenu = false), get_data()"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="6" md="3" class="py-0">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.end_date"
                label=" עד תאריך "
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.end_date"
              @input="(endDateMenu = false), get_data()"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-card>
        <v-card-title>
          <div class="d-flex align-center">
            <v-icon x-large>history</v-icon>
            <h1 class="ms-3">היסטורית</h1>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-data-table
            class="text-center"
            :headers="headers"
            :items="items"
            mobile-breakpoint="0"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.user_name="{ item }">
              {{ item.user.name }}
            </template>
            <template v-slot:item.order_number="{ item }">
              {{ item.order.order_num }}
            </template>
            <template v-slot:item.order_status="{ item }">
              {{ order_status(item.order_status) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <div
        v-if="data_loaded"
        class="text-center mt-4 d-flex justify-center mb-10"
      >
        <v-pagination
          @input="change_page()"
          v-model="page"
          total-visible="7"
          :length="total"
          circle
        ></v-pagination>
        <div class="mr-2 pt-2">
          <v-select
            :value="perpage"
            :items="pagination"
            style="width: 70px"
            hide-details
            dense
            @change="change_page()"
          ></v-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogsTable",
  data() {
    return {
      data_loaded: false,
      total: 0,
      page: 1,

      pagination: [20, 30, 50],
      perpage: 20,
      headers: [
        {
          value: "user_name",
          text: "שם משתמש",
          align: "center",
        },

        {
          value: "order_number",
          text: "מספר סדר",
          align: "center",
        },
        {
          value: "order_status",
          text: "סטטוס סדר",
          align: "center",
        },
        {
          value: "action",
          text: "פעולה",
          align: "center",
        },
        {
          value: "description",
          text: "תיאור",
          align: "center",
        },
        {
          value: "created_at",
          text: "תאריך",
          align: "center",
        },
      ],
      items: [],
      filters: {
        start_date: "",
        end_date: "",
      },
      startDateMenu: false,
      endDateMenu: false,
    };
  },
  computed: {
    order_status: (app) => (status) => {
      const ORDER_STATUS = {
        new: "חדש",
        preparation: "בהכנה",
        done: "הושלם",
        canceled: "בוטל",
        ready: "מוכן",
        in_progress_delivery: "במשלוח",
        delivery_arrived: "המשלוח הגיע",
      };
      return ORDER_STATUS[status];
    },
  },
  methods: {
    change_page() {
      this.data_loaded = false;
      this.get_data();
    },

    get_data() {
      this.$store
        .dispatch("public__request", {
          config: {
            url: `ordersLogs?page=${this.page}&per_page=${this.perpage}&start_date=${this.filters.start_date}&end_date=${this.filters.end_date}`,
            method: "get",
          },
        })
        .then((res) => {
          const data = res.data.data;

          this.data_loaded = true;
          this.items = Object.assign([], data.data);
          this.total = data.last_page;
          this.page = data.current_page;
        });
    },
    delete_row(id) {
      this.delete_obj.id = id;
      this.delete_obj.delete_prop = true;
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>
